import { Component } from 'react'
import { T, C } from '../lib/theme.js'
import { logError } from '../lib/logger.js'

export function NetworkError({ onRetry, message }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'60px 20px', gap:16, textAlign:'center' }}>
      <div style={{ fontSize:'2.5rem' }}>⚠️</div>
      <h3 style={{ fontFamily:'var(--font-display)', fontSize:'1.1rem', fontWeight:700, color:'var(--t1)', margin:0 }}>
        Problème de connexion
      </h3>
      <p style={{ color:'var(--t3)', fontSize:'0.88rem', maxWidth:320, margin:0, lineHeight:1.5 }}>
        {message || 'Impossible de charger les données. Vérifie ta connexion internet.'}
      </p>
      {onRetry && (
        <button onClick={onRetry} style={{
          padding:'10px 24px', borderRadius:10, border:'1px solid var(--gold)',
          background:'transparent', color:'var(--gold)', cursor:'pointer',
          fontFamily:'var(--font-body)', fontWeight:600, fontSize:'0.88rem',
        }}>
          Réessayer
        </button>
      )}
    </div>
  )
}

export class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null } }
  static getDerivedStateFromError(error) { return { hasError: true, error } }
  componentDidCatch(error, info) { logError('ErrorBoundary:', error, info) }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'60px 20px', gap:16, textAlign:'center' }}>
          <div style={{ fontSize:'2.5rem' }}>💥</div>
          <h3 style={{ fontFamily:'var(--font-display)', fontSize:'1.1rem', fontWeight:700, color:'var(--t1)', margin:0 }}>
            Une erreur inattendue s'est produite
          </h3>
          <p style={{ color:'var(--t3)', fontSize:'0.85rem', maxWidth:360, margin:0 }}>
            {this.state.error?.message || 'Erreur inconnue'}
          </p>
          <button onClick={() => { this.setState({ hasError:false, error:null }); window.location.reload() }}
            style={{ padding:'10px 24px', borderRadius:10, border:'1px solid var(--gold)', background:'transparent', color:'var(--gold)', cursor:'pointer', fontFamily:'var(--font-body)', fontWeight:600, fontSize:'0.88rem' }}>
            Recharger la page
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
